import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheCrypt} from "../TheCrypt";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {TheCryptGameAssets} from "../TheCryptGameAssets";
import {TheCryptSymbol} from "../symbols/TheCryptSymbol";
import {TheCryptGameConfig} from "../TheCryptGameConfig";
import {BitmapText} from "pixi.js";


export class TheCryptInitialWinView extends PIXI.Container implements StageLayer {

    public static DELAY_BETWEEN_COMBO_WINS: number = 0;
    private static WIN_ABOVE_LEVEL_01: number = 50;

    private readonly _maxWinNumberWidth: number = 130;

    constructor() {
        super();
        this.name = "TheCryptInitialWinView";
    }

    //Counts all the wins that are below 50 * base bet
    private calculateAboveLevel01LingerTime(): number {
        const winData: IBetWayWinData[] = TheCrypt.model.gameData.betWayWins;
        let belowLevelWins: number = 0;
        for (let i: number = 0; i < winData.length; i++) {
            if (winData[i].multipliedAmount < (TheCryptInitialWinView.WIN_ABOVE_LEVEL_01 * TheCrypt.model.gameData.playedBetValue)) {
                belowLevelWins++;
            }
        }
        return 0.5;// + (belowLevelWins * TheCryptInitialWinView.DELAY_BETWEEN_COMBO_WINS);
    }

    private getStartPosition(symPosition: number[], textWidth:number): number[] {
                const sym: TheCryptSymbol = TheCrypt.realArea.getSymbol(symPosition),
                reelId = symPosition[0],
                    symId = symPosition[1];
                const viewPosition: PIXI.Point = TheCryptGameConfig.reelPositions[reelId];
                let x = viewPosition.x - ((reelId===5 && (textWidth>TheCryptGameConfig.symbolWidth))?4:0);
                return [x, sym.position.y + 50, symId === 0 ? 10 : 100];
    }

    public playWinNumbers(betWayWinData: IBetWayWinData, skipped: boolean, symPosition:number[]): TimelineLite {
        let text = TheCrypt.apiPlugin.currency.formatValue(MathHelper.roundToDecimals(betWayWinData.amount, 2)),
            totalWinWays: number = betWayWinData.numberOfCombinations;
        if (betWayWinData.multiplier > 1) {
            text += ` x ${betWayWinData.multiplier}`;
        }
        let startScale = 1;
        let endScale = startScale;
        let lingerTime = 0;
        const winAboveLevel01LingerTime = this.calculateAboveLevel01LingerTime();
        const textHolder: PIXI.Sprite = new PIXI.Sprite();
        const winNumber = new PIXI.BitmapText(text, {
                fontName: TheCryptGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 20
            }),
            waysNumber = new BitmapText(totalWinWays.toString(), {
                fontName: TheCryptGameAssets.BITMAP_FONT_WIN_WAYS,
                fontSize: 24,
                tint: 0xffffff
            }),
            waysText = new PIXI.Sprite(TheCrypt.assetLoader.getTextures(`Way${totalWinWays > 1 ? "s" : ""}`)[0]);
        winNumber.anchor = new PIXI.Point(0, 1);
        winNumber.position.set(0, 0);

        waysNumber.anchor = new PIXI.Point(0, 0);
        waysText.scale.set(0.4);
        waysText.anchor = new PIXI.Point(0, 0);
        waysNumber.letterSpacing = -12;

        textHolder.alpha = 0;
        textHolder.visible = false;
        textHolder.addChild(winNumber, waysText, waysNumber);
        textHolder.anchor.set(1, 0.1);
        this.addChild(textHolder);
        winNumber.updateTransform();
        if (winNumber.width > this._maxWinNumberWidth) {
            const scale: number = MathHelper.roundToDecimals(this._maxWinNumberWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
        }
        const startPos:number = (winNumber.width-waysNumber.width-waysText.width)*0.5;
        waysNumber.position.set(startPos, 34);
        waysText.position.set(startPos + waysNumber.width, 34);
        const startPositions = this.getStartPosition(symPosition, winNumber.width);
        textHolder.position.set(startPositions[0], startPositions[1]);

        const timeline = gsap.timeline();
        timeline.add([
            ()=>{textHolder.visible = true;},
            gsap.to(textHolder, {duration: 0, alpha: 1}),
            gsap.to(textHolder, {duration: 0.8, y: startPositions[1] - startPositions[2]})
        ], 0);
        timeline.add(gsap.to(textHolder, {duration: 0.4, alpha: 0, delay: lingerTime}));
        timeline.add(() => {
            if (winNumber.parent) {
                this.removeChild(winNumber);
            }
            winNumber.destroy();
            if (waysNumber.parent) {
                this.removeChild(waysNumber);
            }
            waysNumber.destroy();
            waysText.destroy();
            textHolder.destroy();
        });
        if (skipped) {
            timeline.timeScale(4);
        }
        return timeline;
    }

    public findLastNoWildSymbolPosition(betWayWinData: IBetWayWinData): number[] {
        for (let reelId = 5; reelId > -1; reelId--) {
            for (let symId = 0; symId < 6; symId++) {
                if (!betWayWinData.reelWinPositions[reelId][symId]) {
                    continue;
                }
                const sym: TheCryptSymbol = TheCrypt.realArea.getSymbol([reelId, symId]);
                if (!sym) {
                    continue;
                }

                if (!sym.visible) {
                    continue;
                }

                if (sym.name === "W" || sym.name === "Y" || sym.name === "FW") {
                    continue;
                }

                return [reelId,symId];
            }
        }
        debugger
        return [0, 0];
    }
}